import { ColorTypeInterface } from "@/model/components/ColorTypeInterface.ts";

export interface PrintTypeInterface extends ColorTypeInterface {
  text: string;
  type: string;
  [key: string]: string | number | undefined;
}

export const PrintTypes = {
  COLOR: "color",
  MONOCHROME: "monochrome",
  NONE: "none"
} as const;

export interface Type {
  text: string;
  type: string;
}

export interface TypeTable {
  [PrintTypes.COLOR]: {
    [PrintTypes.COLOR]: Type;
    [PrintTypes.MONOCHROME]: Type;
    [PrintTypes.NONE]: Type;
  };
  [PrintTypes.MONOCHROME]: {
    [PrintTypes.COLOR]: Type;
    [PrintTypes.MONOCHROME]: Type;
    [PrintTypes.NONE]: Type;
  };
  [PrintTypes.NONE]: {
    [PrintTypes.COLOR]: Type;
    [PrintTypes.MONOCHROME]: Type;
    [PrintTypes.NONE]: Type;
  };
}

export const typeTable = {
  monochrome: {
    none: {
      text: "【片面印刷】",
      type: "表面モノクロ"
    },
    monochrome: {
      text: "【両面印刷】",
      type: "両面モノクロ"
    },
    color: {
      text: "【両面印刷】",
      type: "表面モノクロ/裏面カラー"
    }
  },
  color: {
    none: {
      text: "【片面印刷】",
      type: "表面カラー"
    },
    color: {
      text: "【両面印刷】",
      type: "両面カラー"
    },
    monochrome: {
      text: "【両面印刷】",
      type: "表面カラー/裏面モノクロ"
    }
  },
  none: {
    none: {
      text: "",
      type: ""
    },
    color: {
      text: "",
      type: ""
    },
    monochrome: {
      text: "",
      type: ""
    }
  }
} as TypeTable;
